import { render, staticRenderFns } from "./CourseContentGroup.vue?vue&type=template&id=582f045f"
import script from "../../services/student/std-course-content-gp.js?vue&type=script&lang=js&external"
export * from "../../services/student/std-course-content-gp.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/upload/content-group.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports